module.exports = __webpack_public_path__ + "Contact_Header_new.48ed80e3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/mobile/headers/Contact_Header_new.png
// module id = +M74
// module chunks = 0